import { CITY_MODES, FIRST_PAGE } from '@/constants';
import * as filterSelectors from '@/filter/filter-selectors';
import * as userSelectors from '@/user/user-selectors';
import { useCallback, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { CardViewer } from './card-viewer';
import CardViewerHeader from './card-viewer-header';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

interface ISortApplied {
  type: unknown;
  order: unknown;
}

export function CardPane() {
  const cityMode = useSelector(userSelectors.derivedCityMode);
  const sortedAndFilteredList = useSelector(
    filterSelectors.sortedAndFilteredList
  );

  // Maintains currently displayed page in state
  const [currentPage, setCurrentPage] = useState(FIRST_PAGE);

  const [sortApplied, setSortApplied] = useState<ISortApplied>({
    type: cityMode === CITY_MODES.trial ? 'apn' : 'latestRevenue',
    order: 'desc',
  });

  const userToggledSort = useCallback((type, order) => {
    setSortApplied({ type, order });
  }, []);

  const propertyList = useMemo(
    () => sortedAndFilteredList(sortApplied.type, sortApplied.order),
    [sortedAndFilteredList, sortApplied]
  );

  return (
    <Wrapper data-testid="property-cards-pane">
      <CardViewerHeader
        userToggledSort={userToggledSort}
        sortApplied={sortApplied}
        setCurrentPage={setCurrentPage}
      />
      <CardViewer
        propertyList={propertyList}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
      />
    </Wrapper>
  );
}
